import React from 'react';
import _ from 'lodash';

import Conditional from '../../../common/conditional';
import PDFPage from '../../../themed/pdf/pdfPage';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';
import PDFPhotoPage from '../../../themed/pdf/pdfPhotoPage';
import VTPipingAnomaly from './vtPipingAnomaly';
import RiskRating from '../riskRating';

import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';
import * as data from '../../../../utils/data';

import config from '../../../../utils/config';

interface VTPDFDataProps {
	data: any[];
	images: models.PDFImageProps[];
	summary: string;
	project: models.Project;
}

const VTPDFData = (props: VTPDFDataProps) => {
	const splitData = (limit: number) => {
		return _.chunk(props.data, limit);
	};

	const renderImages = () => {
		const images = props.data
			.map((item) => item.images)
			.flat()
			.concat(props.images);

		const chunkedImages: models.PDFImageProps[][] = _.chunk(images, 4);
		return chunkedImages.map((images, index) => (
			<PDFPage
				key={index.toString()}
				pageDetails={utils.getPageDetails('Photographic Record')}
				projectDetails={props.project}
				enableTitlePage={index === 0}
			>
				<PDFPhotoPage photos={images} />
			</PDFPage>
		));
	};

	return (
		<React.Fragment>
			{splitData(2).map((items, i: number) => (
				<PDFPage
					key={i.toString()}
					pageDetails={utils.getPageDetails('Anomaly Sheet', 'Anomaly Report')}
					projectDetails={props.project}
					enableTitlePage={i === 0}
				>
					<PDFTablePage data={items} columns={data.getVTTableColumns()} />
				</PDFPage>
			))}

			{splitData(3).map((items, i: number) => (
				<PDFPage
					key={i.toString()}
					pageDetails={utils.getPageDetails('Anomaly Data', 'Summary')}
					projectDetails={props.project}
					enableTitlePage={i === 0}
				>
					<VTPipingAnomaly vtPipingReportSummary={props.summary} data={items} />
				</PDFPage>
			))}

			{renderImages()}

			<Conditional isVisible={config.enableRiskRating}>
				<PDFPage
					pageDetails={utils.getPageDetails('Risk Rating')}
					projectDetails={props.project}
				>
					<Conditional isVisible={props.data.length > 0}>
						<RiskRating data={props.data} />
					</Conditional>
				</PDFPage>
			</Conditional>
		</React.Fragment>
	);
};

export default VTPDFData;
